import React, { Component, Fragment } from "react";
import "./HomeworkView.module.scss";
import { connect } from "react-redux";
import customIsoString from "utilities/custom-iso-string";
import Subject from "components/UI/Subject/Subject";
import Linkify from "react-linkify";

//Import fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//Import components
import CardItem from "../../Card/CardItem/CardItem";
import Button from "components/UI/Button/Button";
import HomeworkBar from "components/UI/SubjectBar/SubjectBar";

import destroyTask from "actions/task/destroy";
import destroyHomework from "actions/homework/destroy";
import updateHomework from "actions/homework/update";
import destroyEvent from "actions/event/destroy";
import {
    homeworkLoadExisting,
    homeworkUpdateDirectInput
} from "actions/new-homework";

const mapStateToProps = (state, props) => {
    return {
        tasks: state.task,
        subjects: state.user_subject.entities,
        user: state.authentication.user,
        colors: state.color.entities
    };
};

const mapDispatchToProps = {
    destroyTask,
    updateHomework,
    destroyHomework,
    homeworkLoadExisting,
    homeworkUpdateDirectInput,
    destroyEvent
};

class HomeworkView extends Component {
    constructor() {
        super();
        this.state = {
            months: [
                "januari",
                "februari",
                "maart",
                "april",
                "mei",
                "juni",
                "juli",
                "augustus",
                "september",
                "oktober",
                "november",
                "december"
            ],
            tasks: []
        };

        this.resetTasks = this.resetTasks.bind(this);
        this.editHomework = this.editHomework.bind(this);
        this.deleteHomework = this.deleteHomework.bind(this);
        this.destroyItem = this.destroyItem.bind(this);
    }

    resetTasks() {
        if (confirm("Weet je zeker dat je alle taken wilt resetten?")) {
            let tasks = this.props.tasks.entities.allIds
                .map(taskId => this.props.tasks.entities.byId[taskId])
                .filter(task => task.homework_id == this.props.homework.id);

            let counter = 0;

            if(tasks.length === 0) {
            //if there are no tasks, update homework directly. 
                this.props
                    .updateHomework({
                        ...this.props.homework,
                        note: this.props.homework.note
                            ? this.props.homework.note
                            : "",
                        hasBeenPlanned: false
                    })
                    .catch(error =>
                        alert(
                            "Er ging iets mis met het bijwerken van het huiswerk"
                        )
                    );
            } else {
                tasks.map(task => {
                    this.props
                        .destroyTask(task.id)
                        .then(result => {
                            counter++;

                            if (counter == tasks.length) {
                                this.props
                                    .updateHomework({
                                        ...this.props.homework,
                                        note: this.props.homework.note
                                            ? this.props.homework.note
                                            : "",
                                        hasBeenPlanned: false
                                    })
                                    .catch(error =>
                                        alert(
                                            "Er ging iets mis met het bijwerken van het huiswerk"
                                        )
                                    );
                            }
                        })
                        .catch(error => console.log(error));
                });
            }
            this.props.handleClose();
        }
    }

    deleteHomework() {
        if (
            confirm(
                "Weet je zeker dat je het huiswerk en de bijbehorende taken wil verwijderen?"
            )
        ) {
            let tasks = this.props.tasks.entities.allIds
                .map(taskId => this.props.tasks.entities.byId[taskId])
                .filter(task => task.homework_id == this.props.homework.id);

            let counter = 0;

            if (tasks.length > 0) {
                tasks.map(task => {
                    this.props
                        .destroyTask(task.id)
                        .then(result => {
                            counter++;

                            if (counter == tasks.length) {
                                this.props
                                    .destroyHomework(this.props.homework.id)
                                    .then(result => {
                                        this.props.handleClose();
                                    })
                                    .catch(error => {
                                        console.error(error);
                                        alert(
                                            "Er ging iets mis met het verwijderen van het huiswerk"
                                        );
                                    });
                            }
                        })
                        .catch(error => console.log(error));
                });
            } else {
                this.props
                    .destroyHomework(this.props.homework.id)
                    .then(result => {
                        this.props.handleClose();
                    })
                    .catch(error => {
                        console.error(error);
                        alert(
                            "Er ging iets mis met het verwijderen van het huiswerk"
                        );
                    });
            }
        }
    }

    editHomework() {
        this.props.handleHomeworkClick();
        this.props.handleClose();
    }

    componentDidMount() {
        let allTasks = this.props.tasks.entities.byId;
        let currentTasks = [];
        let currentHomework = this.props.homework.id;
        Object.keys(allTasks).map(function(key, index) {
            if (allTasks[key].homework_id === currentHomework) {
                currentTasks.push(allTasks[key]);
            }
        });
        this.setState({ tasks: currentTasks });
    }

    destroyItem(type) {
        if (confirm("Weet je zeker dat je dit agenda item wilt verwijderen?")) {
            let data = {};
            if (this.props.period.isRecurring) {
                let date = new Date(this.props.homework.date);

                data = {
                    id: this.props.period.id,
                    redit: type,
                    origid: this.props.period.origid,
                    ristart: customIsoString(date, true),
                    startDateUtc: customIsoString(date, true)
                };
            } else {
                data = {
                    id: this.props.period.id,
                    redit: ""
                };
            }

            this.props
                .destroyEvent(data.id, data)
                .then(() => this.props.handleClose());
        }
    }

    render() {
        const { homework } = this.props;
        if (!homework) {
            return null;
        }

        let subjectId = homework.user_subject_id;
        let subject = this.props.subjects.byId[subjectId];
        let abbreviation = "";
        let color = null;
        if (subject.color_id) {
            color = this.props.colors.byId[subject.color_id];
            color = color && color.color;
        }
        if (subject.subject_abbreviation) {
            abbreviation = subject.subject_abbreviation;
        }
        console.log("tasks", this.state.tasks);

        return (
            <div styleName="input-content">
                <h1 styleName="title">Huiswerk</h1>
                <div styleName="card-content">
                    <HomeworkBar
                        homework={this.props.homework}
                        handleSubjectEditClick={
                            this.props.handleSubjectEditClick
                        }
                        handleDetailsEditClick={
                            this.props.handleDetailsEditClick
                        }
                        disableContextMenu={this.props.past}
                        destroyItem={this.destroyItem}
                        isRecurring={
                            this.props.period && this.props.period.isRecurring
                        } //wordt alleen hier gebruikt? Straks checken. Dan gewoon event in props meegegven
                        color={color}
                        abbreviation={abbreviation}
                        date={homework.date}
                        note={homework.note}
                        image={homework.image}
                        style={{ margin: "0" }}
                    />
                    {!this.props.past && (
                        <Fragment>
                            <div styleName="buttons">
                                <p
                                    onClick={this.editHomework}
                                    styleName="change"
                                >
                                    Huiswerk aanpassen
                                </p>
                                <p
                                    onClick={this.deleteHomework}
                                    styleName="delete"
                                >
                                    Huiswerk verwijderen
                                </p>
                            </div>
                        </Fragment>
                    )}

                    <Fragment>
                        <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                            Opgedeeld in {this.state.tasks.length} taken:
                        </p>

                        {!this.props.past && (
                            <div styleName="amount-steps">
                                <p onClick={this.resetTasks} styleName="reset">
                                    Taken opnieuw indelen
                                </p>
                            </div>
                        )}
                        {this.state.tasks.map((task, index) => {
                            return (
                                <div styleName="tasks">
                                    <div styleName="left">
                                        <Subject
                                            color={color ? color : "#94bfcf"}
                                            abbreviation={abbreviation}
                                            style={{ marginRight: "10px" }}
                                        />
                                        <p styleName="type">
                                            {this.props.homework.type ==
                                                "make" && "M"}
                                            {this.props.homework.type ==
                                                "learn" && "L"}
                                            {this.props.homework.type ==
                                                "make_learn" && "ML"}
                                            {this.props.homework.type ==
                                                "read" && "LZ"}
                                        </p>
                                        <p styleName="task-name">{task.name}</p>
                                    </div>
                                    <div styleName="right">
                                        <p>{task.time}min</p>
                                        {task.status == "finished" && (
                                            <FontAwesomeIcon
                                                icon={["fas", "check"]}
                                            />
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </Fragment>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeworkView);
